export enum ChatSubmissionsActionTypes {
    API_RESPONSE_SUCCESS = '@@chatSubmissions/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@chatSubmissions/API_RESPONSE_ERROR',
    CHAT_SUBMISSIONS_LIST = '@@chatSubmissions/CHAT_SUBMISSIONS_LIST',
}